module.exports = __webpack_public_path__ + "img/login_img2.e366e9ae.webp";